<template>
  <div class="image-container">
    <slot></slot>
    <div class="mask-container" v-show="mask">
      <img
        src="../../../../public/images/common/default-placeholder.png"
        class="mask-img"
      />
    </div>
    <div v-if="item" class="mask-container info-container">
      <div v-if="item.type === 2" class="video-icon"></div>
    </div>
  </div>
</template>

<script>
import { imageLoad } from "../../../utils/media";
import { showErrorMsg } from "../../../utils/errors";
export default {
  name: "ImageShadeComponent",
  props: {
    src: {
      // 图片地址
      type: String,
      default: "",
    },
    item: {
      // 媒体基本信息
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      mask: true,
    };
  },
  async mounted() {
    try {
      if (this.src) {
        await imageLoad({ src: this.src });
        this.mask = false;
      }
    } catch (e) {
      showErrorMsg(e);
    }
  },
};
</script>

<style lang="less" scoped>
.image-container {
  position: relative;
  cursor: pointer;

  .mask-container {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #e9eef1;

    .mask-img {
      width: 50%;
      max-width: 60px;
      display: block;
    }

    &.info-container {
      background: transparent;

      .video-icon {
        width: 55px;
        height: 55px;
        z-index: 2;
        background-size: cover;
        background-image: url("../../../../public/images/schedule_posts/list/video.png");
      }

      .duration {
        position: absolute;
        right: 5px;
        bottom: 5px;
        color: white;
        font-size: 13px;
      }
    }
  }
}
</style>
